<template>
    <div class="md-testimionial reviews-online share-box">
        <a
            target="_blank"
            rel="noopener noreferrer"
            class="item iconfont"
            v-for="(item, index) in sharesInfo"
            :key="index"
            :class="{
                [item.icon]: true
            }"
            :href="item.url"
            :aria-label="item.socialNetwork"
        ></a>
    </div>
</template>

<script>
export default {
    name: 'agent-share',
    props: {
        agentName: {
            type: String,
            default: ''
        },
        socialNetworks: Array
    },
    computed: {
        sharesInfo() {
            return this.socialNetWorkToIcon(
                this.socialNetworks || [
                    {
                        url: `https://www.facebook.com/share.php?u=${this.pageLocation.href}`,
                        socialNetwork: 'facebook'
                    },
                    {
                        url: `https://www.linkedin.com/sharing/share-offsite/?url=${this.pageLocation.href}`,
                        socialNetwork: 'linkedin'
                    },
                    {
                        url: `https://twitter.com/share?text=${this.$t(
                            'md-testimonial.peopleAreSayingGood',
                            { agentName: this.agentName }
                        )}&url=${this.pageLocation.href}`,
                        socialNetwork: 'newtwitter'
                    },
                    {
                        url: `mailTo:?&subject=${this.$t(
                            'md-testimonial.recommendAnAgent'
                        )}&body=${this.$t('md-testimonial.takeALookAt', {
                            href: this.pageLocation.href,
                            interpolation: { escapeValue: false }
                        })}`,
                        socialNetwork: 'google+'
                    }
                ]
            );
        }
    },
    methods: {
        socialNetWorkToIcon(socialNetworks) {
            let shareLinks = socialNetworks.filter(item => {
                switch (item.socialNetwork) {
                case 'google+':
                    item.icon = 'icon-google2';
                    break;
                case 'twitter':
                    item.icon = 'icon-newtwitter-round';
                    break;
                case 'angelist':
                    item.icon = 'icon-angelist'
                    break;
                case 'whatsapp':
                    item.icon = 'icon-whatsapp'
                    break
                default:
                    item.icon = `icon-${item.socialNetwork}-round`;
                }
                return !!item.socialNetwork && !!item.url;
            });
            return shareLinks;
        }
    }
};
</script>

<style lang="scss">
.md-testimionial.reviews-online.share-box {
    $icons: (
        icon-facebook-round: #2d598f,
        icon-linkedin-round: #0e76a8,
        icon-newtwitter-round: #000
    );
    margin-top: 12px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .item {
        margin: 0 6px;
        font-size: 24px;
        @each $key, $value in $icons {
            &.#{$key} {
                color: $value;
            }
        }
        &.icon-google2{
            width: 24px;
            height: 24px;
            &:before {
                border-radius: 50%;
            }
        }
        &.icon-angelist {
            background: rgb(0,47,108);
            border-radius: 50%;
            color: #fff;
            font-size: 18px;
            width: 22px;
            height: 22px;
        }
        &.icon-whatsapp {
            background: transparent;
            border-radius: 50%;
        }
    }
}
</style>
